export default function SectionHero(el, {
    scrollBtnClass,
}) {
    const scrollBtn = el.querySelector(`.${scrollBtnClass}`);

    const scrollContent = () => {
        window.scrollTo({ top: el.offsetHeight, behavior: 'smooth' });
    };

    if (scrollBtn) scrollBtn.addEventListener('click', () => scrollContent());
}
